import React, {Component} from 'react'

import {Card, ButtonCard} from '@amzn/stencil-react-components/card'
import { WithBreakpoints } from '@amzn/stencil-react-components/responsive'

const CARD_WIDTH_VESTING_SUMMARY = "456px"
const CARD_WIDTH_AWARDS = "435px"

class Tile extends Component {

  constructor(props) {
    super(props);
  }

  onTileClick = () => {
    this.props.onTileClick(this.props.obj);
  }

  renderWithCard(height) {
    return (
      <WithBreakpoints>
      {({ matches }) => (
        <>
        {matches.s &&
          <Card dataTestId="tile_Card_s" width="100%" id={this.props.id ? this.props.id : ""}>
            {this.renderCardContent()}
          </Card>
        }
        {!matches.s &&
          <Card
            dataTestId="tile_Card_l"
            width={this.props.isVestingSummary ? CARD_WIDTH_VESTING_SUMMARY : CARD_WIDTH_AWARDS} 
            height={height}
            id={this.props.id ? this.props.id : ""}
          >
            {this.renderCardContent()}
          </Card>
        }
        </>
      )}
      </WithBreakpoints>
    )
  }

  renderWithButtonCard(height) {
    return (
      <WithBreakpoints>
      {({ matches }) => (
        <>
        {matches.s &&
          <ButtonCard
            dataTestId="tile_WithButtonCard_s"
            width="100%"
            id={this.props.id ? this.props.id : ""}
            onClick={this.onTileClick}
          >
            {this.renderCardContent()}
          </ButtonCard>
        }
        {!matches.s &&
          <ButtonCard
            dataTestId="tile_WithButtonCard_l"
            width={this.props.isVestingSummary ? CARD_WIDTH_VESTING_SUMMARY : CARD_WIDTH_AWARDS}
            id={this.props.id ? this.props.id : ""}
            onClick={this.onTileClick}
            height={height}
          >
            {this.renderCardContent()}
          </ButtonCard>
        }
        </>
      )}
      </WithBreakpoints>
    )
  }

  renderTile(isClickable) {
    // provide height parameter to for easier control of tile height, especially when displaying multiple tiles in row
    const height = this.props.height ? this.props.height : "auto";
    if (isClickable) {
      return this.renderWithButtonCard(height);
    }

    return this.renderWithCard(height);
  }
}

export default Tile
